import React from 'react';
import asasPattern3 from "assets/asaspattern3.svg";
import AnalyticalBox from './AnalyticalBox';
import { rows } from "./Rows";
import { useContext } from 'react';
import { ModalContext } from 'hooks/ModalProvider';

interface CrackScreenProps {
  selectedLayers: string[];

}

const CrackScreen: React.FC<CrackScreenProps> = ({ selectedLayers }) => {

  const { setServersModalShown, setRppModalShown } = useContext(ModalContext);
  const isOverviewSelected = selectedLayers.includes("Overview");

  return (
    <>

      <AnalyticalBox label="Crac-1" />

      <div className="max-w-[60%]" >
        <div className=" bg-[#0A3351] rounded-md h-full my-1 flex justify-center items-center w-full max-h-[500px] ">
          <div className="content p-4  w-full">
            {rows.map((row, index) => (
              <>
                {/* Row */}
                <div key={row.id} className="flex cursor-pointer pl-2 gap-2 my-1 w-auto">
                  {/* Blocks */}
                  <div
                    className={`grid grid-cols-[repeat(19,minmax(0,1fr))] gap-2 ${index === 0 ? "items-end" : "items-start"
                      } w-full`}
                  >


                    {index === 0 && row.blocks.map((block: any) => {
                      // 👇 yaha const likho, JSX ke andar nahi
                      let visibleBlocks: any[] = [];

                      if (block.blocks && Array.isArray(block.blocks)) {
                        visibleBlocks = block.blocks.filter((nested: any) => {
                          if (isOverviewSelected) {
                            // ✅ sirf Temperature aur Power Consumption dikhana hai
                            // aur sirf agar block ka color Yellow/Red hai
                            return (
                              ["Temperature", "Power Consumption"].includes(nested.type) && block.color === nested.color && ["#FDBD4D", "#FF5233"].includes(block.color)
                              //   ["#FDBD4D", "#FF5233"].includes(block.color)
                            );
                          } else {
                            // ✅ baaki cases me filter user ke selectedLayers se hoga
                            return selectedLayers.includes(nested.type);
                          }
                        });
                      }

                      return (
                        <div key={block.id} className='cursor-pointer' onClick={() => { block.id === 'RPP' ? setRppModalShown(true) : setServersModalShown(true); }}>
                          {/* ✅ nested blocks render */}
                          {visibleBlocks.length > 0 &&
                            visibleBlocks.map((nested: any) => {
                              if (nested.type === "White Space" && index === 0) {
                                return (
                                  <div
                                    key={nested.id}
                                    className="rounded border-2 h-[70px] w-[26px]"
                                    style={{
                                      borderColor: block.color || "#D4A017",
                                      backgroundImage: `
              repeating-linear-gradient(
                to bottom,
              ${block.color === "#fff" ? "#537085" : block.color}80 0px,
                ${block.color === "#fff" ? "#537085" : block.color}80 20px,
                ${block.color || ' #d4a017'} 20px,
                ${block.color || ' #d4a017'} 21px
              )
            `,
                                      backgroundSize: "100% 21px",
                                      backgroundRepeat: "repeat-y",
                                    }}
                                  >
                                    {/* White Space Label */}
                                    <span
                                      className="text-[10px] font-bold text-[#D4A017] [writing-mode:vertical-rl]"
                                      style={{ transform: "rotate(180deg)" }}
                                    >
                                      {/* {nested.type} */}
                                    </span>
                                  </div>
                                );
                              }

                              // Normal nested block render
                              if (index === 0) {
                                return (
                                  <div
                                    key={nested.id}
                                    className="p-[4px] text-xs font-medium rounded border-2 font-[700] [writing-mode:vertical-rl] h-[80px] flex items-center justify-center gap-2 font-bold"
                                    style={{
                                      borderColor: block.color === "#002E4F4D" ? "#ffffff" : block.color,
                                      backgroundColor: block.color === "#fff" ? "#537085" : `${block.color}80`,
                                      transform: "rotate(180deg)",
                                      color: block.color,
                                    }}
                                  >
                                    {nested.id}
                                    {nested.icon && (
                                      <img src={nested.icon} alt="icon" className="mb-1" />
                                    )}
                                  </div>
                                );

                              }


                            })}

                          <div
                            className={`p-[4px] text-xs font-medium rounded border-2 font-[700] text-white [writing-mode:vertical-rl] h-[80px] flex justify-center`}
                            style={{
                              borderColor: block.color === "#002E4F4D" ? "#ffffff" : block.color,
                              backgroundColor: `${block.color}80`,
                              transform: "rotate(180deg)",
                            }}
                          >
                            {block.id}
                          </div>
                        </div>
                      );
                    })}


                    {index === 1 && row.blocks.map((block: any) => {
                      // 👇 yaha const likho, JSX ke andar nahi
                      let visibleBlocks: any[] = [];

                      if (block.blocks && Array.isArray(block.blocks)) {
                        visibleBlocks = block.blocks.filter((nested: any) => {
                          if (isOverviewSelected) {
                            return (
                              ["Temperature", "Power Consumption"].includes(nested.type) && block.color === nested.color && ["#FDBD4D", "#FF5233"].includes(block.color)
                              //   ["#FDBD4D", "#FF5233"].includes(block.color)
                            );
                          } else {
                            return selectedLayers.includes(nested.type);
                          }
                        });
                      }

                      return (
                        <div key={block.id} onClick={() => { block.id === 'RPP' ? setRppModalShown(true) : setServersModalShown(true); }}>
                          <div
                            className={`p-[4px] text-xs font-medium rounded border-2 font-[700] text-white [writing-mode:vertical-rl] h-[80px] flex justify-center`}
                            style={{
                              borderColor: block.color === "#002E4F4D" ? "#ffffff" : block.color,
                              backgroundColor: `${block.color}80`,
                              transform: "rotate(180deg)",
                            }}
                          >
                            {block.id}
                          </div>
                          {visibleBlocks.length > 0 &&
                            visibleBlocks.map((nested: any) => {
                              if (nested.type === "White Space" && index === 1) {
                                return (
                                  <div
                                    key={nested.id}
                                    className="rounded border-2 h-[70px] w-[26px]"
                                    style={{
                                      borderColor: block.color || "#D4A017",
                                      backgroundImage: `
              repeating-linear-gradient(
                to bottom,
                ${block.color === "#fff" ? "#537085" : block.color}80 0px,
                ${block.color === "#fff" ? "#537085" : block.color}80 20px,
                ${block.color || ' #d4a017'} 20px,
                ${block.color || ' #d4a017'} 21px
              )
            `,
                                      backgroundSize: "100% 21px",
                                      backgroundRepeat: "repeat-y",
                                    }}
                                  >
                                    {/* White Space Label */}
                                    <span
                                      className="text-[10px] font-bold text-[#D4A017] [writing-mode:vertical-rl]"
                                      style={{ transform: "rotate(180deg)" }}
                                    >
                                      {/* {nested.type} */}
                                    </span>
                                  </div>
                                );
                              }

                              // Normal nested block render
                              if (index === 1) {
                                return (
                                  <div
                                    key={nested.id}
                                    className="p-[4px] text-xs font-medium rounded border-2 font-[700] [writing-mode:vertical-rl] h-[80px] flex items-center justify-center gap-2 font-bold"
                                    style={{
                                      borderColor: block.color === "#002E4F4D" ? "#ffffff" : block.color,
                                      backgroundColor: block.color === "#fff" ? "#537085" : `${block.color}80`,
                                      transform: "rotate(180deg)",
                                      color: block.color,
                                    }}
                                  >
                                    {nested.id}
                                    {nested.icon && (
                                      <img src={nested.icon} alt="icon" className="mb-1" />
                                    )}
                                  </div>
                                );

                              }


                            })}





                          {/* ✅ fallback simple block */}
                          {/* {block.blocks && ( */}
                          {/* <div
            className={`p-[4px] text-xs font-medium rounded border-2 font-[700] text-white [writing-mode:vertical-rl] h-[80px] flex justify-center`}
            style={{
              borderColor: block.color === "#002E4F4D" ? "#ffffff" : block.color,
              backgroundColor: `${block.color}80`,
              transform: "rotate(180deg)",
            }}
          >
            {block.id}
          </div> */}
                          {/* // )} */}
                        </div>
                      );
                    })}


                  </div>

                  {/* Row Label */}
                  <div className="row-title rounded-md flex items-center justify-center  w-[30px]">
                    <h4 className="text-sm font-semibold text-white [writing-mode:vertical-rl] rotate-180">
                      {row.label}
                    </h4>
                  </div>

                </div>
                {rows.length - 1 !== index && rows.length > 1 && (

                  <div className="flex h-full relative overflow-hidden"
                    style={{ width: "calc(100% - 30px)" }}
                  >
                    {/* <div className="h-full w-[7px] bg-gradient-to-r from-[#7ED34E] to-[#2E968A]  absolute left-0"></div> */}
                    <img src={asasPattern3} alt="asas-pattern" className='w-full h-full' />
                    {/* <div className="h-full  w-[7px]  bg-gradient-to-r from-[#7ED34E] to-[#2E968A] absolute right-0"></div> */}
                  </div>
                )}
              </>
            ))}

          </div>

        </div>





      </div>

      <AnalyticalBox label="Crac-5" />
    </>
  );
};

export default CrackScreen;